import { configureStore } from '@reduxjs/toolkit';

import ControlTowerTabReducer from "./slices/control-tower-tab-slice";
import LotSizeOptimizationTabReducer from "./slices/lot-size-optimization-tab-slice";
import MasterTablesTabReducer from "./slices/master-tables-tab-slice";
import PlanningParametersTabReducer from "./slices/planning-parameters-tab-slice";
import PromotionPlanningReducer from "./slices/promotion-planning-tab-slice";
import PromoMasterReducer from "./slices/promo-master-tab-slice";
import ReplenishmentTabReducer from "./slices/replenishment-tab-slice";
import TradeAndPromoPlanningReducer from "./slices/trade-and-promo-planning-tab-slice";
import VolumeForecastReducer from "./slices/volume-forecast-tab-slice";
import ForecastReviewReducer from "./slices/forecast-review-tab-slice";
import AnnualSummaryReducer from "./slices/annual-summary-tab-slice";
import TradeSpendReportReducer from "./slices/trade-spend-report-tab-slice";

const store = configureStore({
  reducer: {
    replenishmentTab: ReplenishmentTabReducer,
    lotSizeOptimizationTab: LotSizeOptimizationTabReducer,
    planningParametersTab: PlanningParametersTabReducer,
    masterTables: MasterTablesTabReducer,
    controlTowerTab: ControlTowerTabReducer,
    tradeAndPromoPlanningTab: TradeAndPromoPlanningReducer,
    volumeForecastTab: VolumeForecastReducer,
    promotionPlanning: PromotionPlanningReducer,
    promoMasterTab: PromoMasterReducer,
    forecastReviewTab: ForecastReviewReducer,
    annualSummaryTab: AnnualSummaryReducer,
    tradeSpendReportTab: TradeSpendReportReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;